export default __webpack_public_path__ + "static/media/linkedin.927b88a0.svg";